export default "__VITE_ASSET__CLeTAnuy__"